namespace SP {
    export enum PickAlgorithm {
        Point = 0,
        AllPoints = 1,
        Snake = 2,
    }
}